import { COMPANY_PHONE_NUMBER } from './app.constants';
import { StepCard } from '../pages/check-pets-chip/check-pets-chip.component';

export const CheckChip: StepCard[] = [
  {
    title: 'Your chip is registered with identibase',
    text: ` Congratulations your pet has an identichip! Login via our website, app or call our contact centre on ${COMPANY_PHONE_NUMBER} to check their details.`,
    button: 'Login',
  },
  {
    title: 'Your chip is registered with another database',
    text: `Contact your database to make sure your pet's details are up to date.`,
    secondaryText: `Don't forget! You can always switch to identibase and take advantage of our exclusive pet protection plans - `,
    link: 'Learn more here',
    linkRedirect:
      'https://identicare.zendesk.com/hc/en-gb/articles/12334630192541-How-do-I-transfer-from-another-database-to-identibase',
  },
  {
    title: 'Your chip is not registered with a UK database',
    text: `This can happen if your pet's chip has not been sourced from a UK provider. Not to worry! Call us on ${COMPANY_PHONE_NUMBER}
        to get the chip registered with identibase, free of charge.`,
  },
  {
    title: 'Your chip is registered with two databases',
    text: `In some cases, the chip checker may list two or more different databases. For the purpose of pet welfare, it is recommended that your pet's details are only held on a single <b>DEFRA approved</b> database.`,
  },
];

export const UsefulLinks: StepCard[] = [
  {
    link: 'The Law for Microchipping Cats is Changing!',
    linkRedirect:
      'https://identiblog.zendesk.com/hc/en-us/articles/10356895037597-The-Law-for-Microchipping-Cats-is-Changing',
    img: 'assets/images/purina/purina-article-1.jpeg',
    background: '325px',
  },
  {
    link: "Figaro's Incredible Journey: 500 Miles later",
    linkRedirect:
      'https://identiblog.zendesk.com/hc/en-us/articles/18015346673693-Figaro-s-Incredible-Journey-500-Miles-later',
    img: 'assets/images/purina/purina-article-2.png',
    background: '250px 218px',
  },
  {
    link: 'Microchipping vs GPS',
    linkRedirect:
      'https://identiblog.zendesk.com/hc/en-us/articles/6140937142813-Microchipping-vs-GPS',
    img: 'assets/images/purina/purina-article-3.png',
    background: '415px',
  },
];
